<template>
  <div v-if="visible" class="progress fixed-top" style="height: 5px; z-index: 1060">
    <div
      class="progress-bar progress-bar-animated bg-secondary"
      role="progressbar"
      :style="{ width: progress + '%' }"
    ></div>
  </div>
</template>

<script setup lang="ts">
import { useProgressBar } from '@/composable/progressBar';

const { progress, visible } = useProgressBar();
</script>
